// TODO - code duplication with Note.js
angular.module('clientDashboardApp').directive('cmCommentGroup', function () {
  return {
    template: require('./comments.html'),
    restrict: "A",
    scope: {
      entityId: '=',
      tags: '=',
      settings: '=',
      onClose: '=',
      total: '='
    },
    controller: function CommentsCtrl ($scope, $rootScope, noteService, $timeout, confirmService) {
      const vm = this;
      $scope.vm = vm;
      $scope.assetUrl = $rootScope.assetUrl;

      $scope.$on('newCommentFor', (event, {entityId}) => {
        if (entityId == $scope.entityId) {
          vm.newNote()
        }
      })

      const entityId = $scope.entityId + ""
      const type = $scope.settings.type
      const tags = ($scope.tags || []).filter(_.isString)
      const settings = $scope.settings
      vm.entityNotes = []
      $scope.something = entityId

      const getNotes = () => {
        noteService.getNotes([entityId], type, tags).then(data => {
          _.each(data, note => note.noteDetail = noteService.processAsHtml(note.noteDetail))
          vm.entityNotes = data
          $scope.total = data.length
        })
      }

      getNotes()

      vm.notes = {
        notesForm: {},
        isSelectedRow: false,
        selectedRowId: null,
        tempNotesArray: null,
        showNotes: true,
        editNote: false,
        updating: false,
        showVisibilityCheckbox: false,
        tempNoteAddDetail: null,
        defaultVisibilitySetting: "Standard",
        defaultVisibilityChecked: false,
        deleteTarget: {
          entity: null,
          note: null
        },
        tempNoteEditPristine: {},
        tempNoteEdit: null,
        tempNoteAdd: {
          entityId: "",
          noteType: "",
          dateAdded: "",
          lastUpdated: "",
          userId: "",
          userName: "",
          firstName: "",
          lastName: "",
          visibility: "Standard",
          noteDetail: ""
        }
      }

      vm.visibilityOptions = [
        {
          id: "Admin",
          name: "Admin"
        },
        {
          id: "Standard",
          name: "All"
        }
      ]

      vm.notes.isAdmin = () => settings.userInfo.permissions.indexOf('NoteAdmin') >= 0;

      vm.noteVisible = function (note) {
        return (settings.userInfo.permissions.indexOf('NoteAdmin') >= 0 && note.visibility === "Admin") || note.visibility === "Standard";
      }

      vm.newNote = () => {
        vm.hideVisibilityCheckbox()
        vm.notes.isSelectedRow = true
        vm.notes.editNote = true
        vm.notes.tempNoteAdd.noteDetail = null
        vm.notes.notesForm.$pristine = true
        vm.notes.notesForm.$dirty = false
        $timeout(() => $('.cm-note-new textarea').focus())
      }

      vm.canEdit = note => settings.userInfo.userId === note.userId || vm.notes.isAdmin()

      vm.editNote = note => {
        if (vm.notes.tempNoteEdit != null) {
          vm.notes.tempNoteEdit.editing = false
          vm.notes.tempNoteEdit.noteDetail = noteService.processAsHtml(vm.notes.tempNoteEditPristine.noteDetail)
        }

        note.editing = true
        angular.copy(note, vm.notes.tempNoteEditPristine)
        vm.notes.tempNoteEdit = note
        vm.notes.tempNoteEditPristine.noteDetail = noteService.processFromHtml(vm.notes.tempNoteEditPristine.noteDetail)
        vm.notes.tempNoteEdit.noteDetail = noteService.processFromHtml(vm.notes.tempNoteEdit.noteDetail)
        $timeout(() => $('#cm-comment-' + note._id + ' textarea').focus())
      }

      vm.cancelEditNote = () => {
        if (vm.notes.tempNoteEdit != null) {
          vm.notes.tempNoteEdit.editing = false
          vm.notes.tempNoteEdit.noteDetail = noteService.processAsHtml(vm.notes.tempNoteEditPristine.noteDetail)
        }
      }

      vm.cancelNewNote = () => {
        vm.notes.editNote = false;
        if ($scope.onClose) {
          $scope.onClose()
        }
      }

      vm.updateNote = note => {
        note.noteDetail = noteService.processAsHtml(note.noteDetail)
        vm.noteUpdateRequest = angular.copy(note)
        vm.noteUpdateRequest.filters = tags
        vm.noteUpdateRequest.noteDetail = noteService.processFromHtml(vm.noteUpdateRequest.noteDetail)
        vm.notes.tempNoteEdit = null
        delete note.editing
        noteService.updateNote(vm.noteUpdateRequest)
      }

      vm.deleteNote = note => confirmService.confirm(
        'Are you sure you want to delete this Note?',
        'Once the note is deleted you cannot recover it.',
        confirmService.WARNING
      ).then(confirmedDelete => {
        if (confirmedDelete) {
          noteService.deleteNote(note._id).then(() => {
            const delIndex = _.findIndex(vm.entityNotes, n => n._id == note._id)
            vm.entityNotes.splice(delIndex, 1)
          })
        }
      })


      vm.saveNote = () => {
        vm.notes.updating = true
        var addNoteRequest = {}

        angular.copy(vm.notes.tempNoteAdd, addNoteRequest)
        addNoteRequest.noteType = type
        addNoteRequest.entityId = entityId
        addNoteRequest.filters = tags
        addNoteRequest.userId = settings.userInfo.userId
        addNoteRequest.firstName = settings.userInfo.firstName
        addNoteRequest.lastName = settings.userInfo.lastName
        addNoteRequest.userName = settings.userInfo.username
        addNoteRequest.noteDetail = noteService.stripHtml(addNoteRequest.noteDetail)

        noteService.addNote(addNoteRequest).then(() => {
          getNotes()
          vm.notes.editNote = false
          vm.notes.updating = false
        })
      }

      vm.showVisibilityCheckbox = () => {
        vm.notes.showVisibilityCheckbox = true
        vm.notes.defaultVisibilityChecked = false
      }

      vm.hideVisibilityCheckbox = () => vm.notes.showVisibilityCheckbox = false
      vm.hasError = el => ((el.$error.required || el.$error.maxlength ) && el.$dirty)

    },

  }
})


